// extracted by mini-css-extract-plugin
export default {"cardOverride":"TeamSwitcher_cardOverride__mz8zA"};